module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-on-center close-picker rowBackgroundHomepage",
    attrs: {
      "id": "inbox",
      "data-page": "inbox-page"
    }
  }, [_c('div', {
    staticClass: "page-content infinite-scroll",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('div', {
    staticClass: "listPage"
  }, [_c('div', {
    staticClass: "row showLargeScreenOnly"
  }, [_c('div', {
    staticClass: "row rowSearchBar"
  }, [_c('back-button', {
    staticClass: "firstBlock"
  }), _vm._v(" "), _c('extract-csv-button', {
    on: {
      "startCSVextraction": function($event) {
        return _vm.extractCSV(_vm.paymentsList)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "milkyBlockBlack firstBlock new-button-white",
    on: {
      "click": function($event) {
        return _vm.refreshPaymentsGroup()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "refresh"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "showLargeScreenOnly fab-label"
  }, [_vm._v("\r\n              " + _vm._s(_vm.$t('common.rfrsh')) + "\r\n            ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "searchForm col-md-12"
  }, [_c('div', {
    staticClass: "requestsList"
  }, [_c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": true,
      "received": true,
      "listMainTitle": _vm.currentPaymentsGroup[0].groupname,
      "filterType": 'details'
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }), _vm._v(" "), _c('f7-accordion-item', {
    staticClass: "accordionForm",
    attrs: {
      "expanded": true
    }
  }, [_c('f7-accordion-toggle', {
    staticClass: "accordionToggle"
  }, [_c('transactions-list', {
    staticStyle: {
      "border-radius": "0"
    },
    attrs: {
      "filterBy": false,
      "messages": _vm.currentPaymentsGroup,
      "serviceId": _vm.serviceId
    }
  })], 1), _vm._v(" "), _c('f7-accordion-content', [(_vm.activateSpinner) ? _c('spinner') : (_vm.detailsDone) ? _c('direct-payments-list', {
    attrs: {
      "filterBy": false,
      "payments": _vm.paymentsList,
      "showPaymentMainDetails": true
    },
    on: {
      "get-folder-info": function($event) {
        return _vm.getFolderInfo()
      }
    }
  }) : _vm._e()], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c6d8c0d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6d8c0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/directPaymentDetailPages/GroupDirectPaymentDetailPage.vue
// module id = 2304
// module chunks = 2